import React from 'react';

import { ScrollArea } from '@app/shared/ui/atoms/Common';
import { AdminHeader } from '@app/shared/ui/organisms/Admin/Layout';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  return (
    <ScrollArea>
      <AdminHeader />
      {children}
    </ScrollArea>
  );
}
